import React, { useState } from "react";
import { Checkbox, Divider } from "antd";
const Avatar = ({ avatarUrl, nickName, itemWidth = 60, imgHeight = 30, role }) => {
  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: itemWidth,
          boxSizing: "border-box",
          padding: 2,
        }}
      >
        <img
          src={avatarUrl}
          alt="头像"
          style={{ height: imgHeight, borderRadius: `${imgHeight}px` }}
        />
        <span
          style={{
            width: "100%",
            fontSize: 10,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            textAlign: "center",
            color: role === 0 ? 'red' : '#555'
          }}
        >
          {nickName}
        </span>
      </div>
    </div>
  );
};
export default Avatar;
